module.exports = __webpack_public_path__ + "img/722.df648ebc.jpg";